<template>
    <div class="add_wxResourse_mask"  v-if="addOk">
    <el-card class="add_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">新建公众号</span>
        </div>
        <div class="resourseContent">
            <p>
                <span class="col-lg-1">公众号名字:</span><el-input class="col-lg-2" v-model="name"></el-input>
            </p>
            <p>
                <span class="col-lg-1">公众号文章链接:</span><el-input class="col-lg-2" v-model="link"></el-input>
            </p>
            <p>
                <span class="col-lg-1">公众号描述:</span><el-input class="col-lg-2" v-model="content"></el-input>
            </p>
            <p>
                <span class="col-lg-1" style="float:left;">公众号LOGO:</span>
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    :show-file-list="false"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList1">
                    <el-button size="small" type="primary" @click="ctrlType(0)">选择文件</el-button>
                </el-upload>
                <span :style="green1">{{img1!=''?img1:'(提示:请选择m*m px的Logo)'}}</span>
            </p>
            <p style="display: inline-block;width: 100%;">
                <span class="col-lg-1" style="float:left;">公众号二维码:</span>
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    :show-file-list="false"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList2">
                    <el-button size="small" type="primary" @click="ctrlType(1)">选择文件</el-button>
                </el-upload>
                <span :style="green2">{{img2!=''?img2:'(提示:请选择m*m px的二维码)'}}</span>
            </p>
            <p style="text-align:center;margin-top:60px;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow'],
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          fileList1: [],
          fileList2: [],
          form: {},
          name: '',
          link: '',
          myType: 0,
          content: '',
          img1: '',
          img2: '',
          isMultiple: true
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        green1: function () {
          return this.img1 !== '' ? 'color:green' : ''
        },
        green2: function () {
          return this.img2 !== '' ? 'color:green' : ''
        },
        myForm: {
          set: function (value) {
            this.form = value
          },
          get: function () {
            return this.form
          }
        }
      },
      created: function () {
        this.getUpToken()
      },
      methods: {
        boxColose () {
          this.link = ''
          this.img1 = ''
          this.img2 = ''
          this.name = ''
          this.content = ''
          this.$emit('closeAddAccount', false)
        },
        getUpToken () {
          var myUrl = 'http://platform.songzb.com:32000/qiniuToken'
          var _this = this
          $ajax.get(myUrl, '', '', function (res) {
            _this.form.token = res.uptoken
          }, function () {
          })
        },
        handlePreview (file) {
        },
        handleBeforeUpload (file) {
          var last
          last = file.name.split('.').pop()
          if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
            this.$message({
              type: 'error',
              message: '图片格式错误'
            })
            return false
          }
          var str = 'zdsimg-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
          this.form.key = str
        },
        handleSuccess (response, file, fileList) {
          if (this.myType === 0) {
            this.img1 = 'http://res.songzb.com/' + response.key
          } else {
            this.img2 = 'http://res.songzb.com/' + response.key
          }
        },
        ctrlType (type) {
          if (type === 0) {
            this.myType = 0
          } else {
            this.myType = 1
          }
        },
        commit () {
          var that = this
          var params = {
            name: this.name,
            wx_logo: this.img1,
            qrcode: this.img2,
            wxArticleUrl: this.link,
            description: this.content
          }
          if (this.name.trim() === '') {
            that.$message({
              type: 'error',
              message: '公众号名字不能为空'
            })
            return
          }
          if (this.link.trim() === '') {
            that.$message({
              type: 'error',
              message: '公众号链接不能为空'
            })
            return
          }
          if (this.content.trim() === '') {
            that.$message({
              type: 'error',
              message: '公众号描述不能为空'
            })
            return
          }
          if (this.img1 === '' || this.img2 === '') {
            that.$message({
              type: 'error',
              message: '请选择要上传的资源！'
            })
            return
          }
          $ajax.post('device/addWeixin', params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '添加公众号资源成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_wxResourse_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
  .add_account {
    min-height: 530px;
    width: 766px;
    top: 20%;
    left: 41%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .upload-demo {
        float: left;
        margin-right: 30px;
    }
    .col-lg-1 {
        width: 25%;
        display: inline-block;
        font-weight: 700;
        color: #777;
        vertical-align: top;
    }
    .col-lg-2 {
        width: 70%;
        display: inline-block;
        margin-bottom: 20px;
        textarea {
          height: 120px;
        }
    }

  }
  }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/addWxResourse.vue